<template>
    <NuxtLayout name="default">
        <account-floating-action-button />

        <div class="flex grow layout-account">
            <account-sidebar />

            <div class="flex-1 flex flex-col overflow-x-hidden">
                <BreadCrumbNavigation />

                <div class="py-8 px-6 lg:mt-8 lg:p-20 grow max-w-screen">
                    <!-- Small alert that some actions might not be available -->
                    <layout-maintenance class="mb-12" />

                    <account-address-verification-modal />
                    <wallet-redownload-modal />
                    <promotion-app-banner />

                    <slot />
                </div>

                <layout-footer />
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
const { loadVisits } = useNavigationVisits();

onMounted(() => {
    loadVisits();
});
</script>
